module.exports = __webpack_public_path__ + "static/media/banner-blog.7a0891aa.svg";